/**
 * Utility functions for detecting and handling Vercel deployment environments
 */

/**
 * Get the current deployment URL
 * Uses Vercel-provided URL if available, otherwise falls back to configured APP_URL
 */
export function getDeploymentUrl(): string {
  // Use Vercel-provided URL if available (for preview and production deployments)
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }

  // Fallback to configured APP_URL (for local development)
  return process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000';
}

/**
 * Check if the current environment is a Vercel preview deployment
 */
export function isPreviewDeployment(): boolean {
  return process.env.VERCEL_ENV === 'preview';
}

/**
 * Check if the current environment is a Vercel production deployment
 */
export function isProductionDeployment(): boolean {
  return process.env.VERCEL_ENV === 'production';
}
